<!-- A small winged sheep hovering over a cloud. Rendered here at rest; SheepHover animates it in the browser. -->
<svg class="tsh" viewBox="0 0 140 100" aria-hidden="true">
  <defs>
    <clipPath id="tsh-cloud-clip"><path [attr.d]="cloud"/></clipPath>
  </defs>

  <g class="tsh-cloud" [attr.transform]="pose.cloud">
    <path class="tsh-cloud__body" [attr.d]="cloud"/>
    <!-- The sheep's shadow on the cloud top, softer and smaller the higher it flies -->
    <g clip-path="url(#tsh-cloud-clip)">
      <ellipse class="tsh-shadow" cx="0" [attr.cy]="cloudTop + 2" rx="17" ry="3.6"
               [attr.transform]="pose.shadow" [attr.opacity]="pose.shadowOpacity"/>
    </g>
  </g>

  <g class="tsh-sheep" [attr.transform]="pose.sheep">
    <g class="tsh-wing tsh-wing--far">
      <path [attr.d]="pose.farWing"/>
      <path class="tsh-wing__lines" [attr.d]="pose.farWingLines"/>
    </g>
    <path class="tsh-legs tsh-legs--far" [attr.d]="pose.farLegs"/>
    <path class="tsh-legs tsh-legs--near" [attr.d]="pose.nearLegs"/>

    <!-- Wool: outlines underneath, fills on top, so only the outer edge shows -->
    <g class="tsh-wool" [attr.transform]="pose.wool">
      <g class="tsh-fleece tsh-fleece--outline">
        @for (puff of wool; track $index) { <circle [attr.cx]="puff.cx" [attr.cy]="puff.cy" [attr.r]="puff.r"/> }
      </g>
      <g class="tsh-fleece">
        @for (puff of wool; track $index) { <circle [attr.cx]="puff.cx" [attr.cy]="puff.cy" [attr.r]="puff.r"/> }
      </g>
    </g>

    <g class="tsh-head" [attr.transform]="pose.head">
      <ellipse class="tsh-ear" cx="-2" cy="2.5" rx="4.6" ry="2" transform="rotate(-20 -2 2.5)"/>
      <ellipse class="tsh-face" cx="7" cy="5" rx="9.5" ry="6.5" transform="rotate(35 7 5)"/>
      <g class="tsh-fleece tsh-fleece--outline">
        @for (puff of forelock; track $index) { <circle [attr.cx]="puff.cx" [attr.cy]="puff.cy" [attr.r]="puff.r"/> }
      </g>
      <g class="tsh-fleece">
        @for (puff of forelock; track $index) { <circle [attr.cx]="puff.cx" [attr.cy]="puff.cy" [attr.r]="puff.r"/> }
      </g>
      <g class="tsh-eye" [attr.transform]="pose.eye">
        <circle class="tsh-eye__white" [attr.cx]="eye.x" [attr.cy]="eye.y" r="1.5"/>
        <circle class="tsh-eye__pupil" [attr.cx]="eye.x + .45" [attr.cy]="eye.y + .1" r=".8"/>
      </g>
    </g>

    <g class="tsh-wing tsh-wing--near">
      <path [attr.d]="pose.nearWing"/>
      <path class="tsh-wing__lines" [attr.d]="pose.nearWingLines"/>
    </g>
    <path class="tsh-tuft" [attr.d]="shoulderTuft"/>
    <path class="tsh-tuft__edge" [attr.d]="shoulderTuftEdge"/>
  </g>
</svg>
